import { useState } from "react";
import { Box, Typography, Modal } from "@mui/material";
import moment from "moment";
import { CheckCircle, User, X } from "phosphor-react";
import UserAvatar from "../../Utilities/UserAvatar/UserAvatar.component";
import { Avatar, Tooltip } from "@material-ui/core";

const VRSessionTranscript = ({
  transcription,
  seekAudio,
  fileUrls,
  player,
}) => {
  const [open, setOpen] = useState(false);
  // Convert seconds to mm:ss
  const secondsToTimestamp = (seconds) => {
    return moment.utc(seconds * 1000).format("mm:ss");
  };

  // Convert timestamp string (HH:mm:ss or MM:SS) or number to seconds
  const timestampToSeconds = (timestamp) => {
    // If it's already a number (seconds), return it
    if (typeof timestamp === "number") return timestamp;

    // If it's a string, parse it
    if (typeof timestamp === "string") {
      const parts = timestamp.split(":");
      if (parts.length === 3) {
        // Format: "HH:mm:ss"
        return (
          parseInt(parts[0]) * 3600 +
          parseInt(parts[1]) * 60 +
          parseInt(parts[2])
        );
      } else if (parts.length === 2) {
        // Format: "MM:SS"
        return parseInt(parts[0]) * 60 + parseInt(parts[1]);
      }
    }

    // Fallback: try parseInt (for numeric strings)
    const parsed = parseInt(timestamp);
    return isNaN(parsed) ? 0 : parsed;
  };

  return (
    <Box
      sx={{
        padding: "6px 4px 12px 4px",
        borderBottom: "1px solid #252A38",
        borderRadius: "5px",
        "&:hover": {
          backgroundColor: "#252A38",
          borderRadius: "6px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {transcription.speaker && (
            <>
              <Tooltip title={transcription.speaker}>
                <Avatar
                  sx={{
                    height: "30px",
                    width: "30px",
                    textAlign: "center",
                    borderRadius: "50%",
                    backgroundColor: "#6C65D9",
                    color: "#000000",
                    fontWeight: "400 !important",
                    fontSize: "15px",
                  }}
                >
                  {transcription.speaker?.split("_")[0]?.charAt(0) || ""}
                  {transcription.speaker?.split("_")[1] || ""}
                </Avatar>
              </Tooltip>
              <Typography sx={{ fontSize: "13px", color: "#B1B5C9" }}>
                {transcription.speaker}
              </Typography>
            </>
          )}
        </Box>
        <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <CheckCircle size={20} color="#00FF444D" weight="fill" />
          <Typography
            sx={{ fontSize: "14px", color: "#B1B5C9", cursor: "pointer" }}
            onClick={() => {
              if (seekAudio) {
                seekAudio(transcription.audio_timestamp_seconds);
              }
            }}
          >
            {transcription.type === "annotation"
              ? transcription.sessionTimestamp
              : transcription.start}
          </Typography>
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "8px",
          marginTop: "8px",
        }}
      >
        <Typography
          sx={{ fontSize: "14px", color: "#52CBFF", cursor: "pointer" }}
          onClick={() => {
            if (player.current) {
              if (transcription.type === "annotation") {
                player.current.currentTime = parseInt(
                  timestampToSeconds(transcription.screenShotTime),
                );
              } else {
                player.current.currentTime = transcription.video_time;
              }
            }
          }}
        >
          {transcription.type === "annotation"
            ? transcription.screenShotTime
            : transcription.video_time
              ? secondsToTimestamp(transcription.video_time)
              : ""}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          {transcription.type === "annotation" && transcription.file_name && (
            <img
              onClick={() => setOpen(true)}
              src={fileUrls[transcription.file_name]}
              alt="Annotation"
              style={{
                width: "270px",
                height: "140px",
                objectFit: "cover",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            />
          )}
          <Typography
            sx={{
              fontSize: "14px",
              color: "#ECECEC",
            }}
          >
            {transcription.text || transcription.description}
          </Typography>
        </Box>
      </Box>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            outline: "none",
            height: "80vh",
            width: "65%",
          }}
        >
          <X
            size={30}
            style={{ alignSelf: "flex-end", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
          <img
            src={fileUrls[transcription.file_name]}
            height="90%"
            width="100%"
            onContextMenu={(e) => e.preventDefault()}
            alt="from annotate"
          ></img>
        </div>
      </Modal>
    </Box>
  );
};

export default VRSessionTranscript;
